// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SessionEngineCapacityDurationResponse

export type SessionEngineCapacityDurationApiResponse = {
	min: number;
	max: number;
	duration: number;
};

export type SessionEngineCapacityDuration = {
	min: number;
	max: number;
	duration: number;
};

export function hydrateSessionEngineCapacityDuration(data: SessionEngineCapacityDurationApiResponse): SessionEngineCapacityDuration {
	return { ...data };
}